<template lang="pug">
.drawer.relative.text-primary-text.cursor-pointer
  Teleport(to="body")
    .backdrop.fixed.inset-0.z-40(v-show="visible", @click="toggle")
    transition(name="slide-up")
      DrawList(v-if="visible", @click="toggle")
  // 小怪物
  .flex.flex-col.items-center.w-full
    div(:class="['h-14', 'pb-[0.5rem]', 'portrait:pb-[0.25rem]', 'portrait:h-17.5', 'mb-1.5']", @click="toggle('menu')")
      img.w-full.h-full.object-contain(:src="accountLevelReachedImage")
    span.absolute.inset-x-0.bottom-1.leading-none.font-medium(class="portrait:bottom-0") {{ $t('common.menu') }}
  transition(name="pan-fade")
    .needHelp.absolute.z-10.w-20.h-12.-end-12.py-2.ps-2.pe-3(v-show="showNeedHelp", class="top-[-70%] portrait:w-24 portrait:h-14")
      img.absolute.inset-0(:src="indexImgHelpdialogNormal")
      .relative.z-10.flex.justify-center.items-center.h-full.text-xs.text-shadow {{ $t('title.need_help') }}
</template>

<script setup>
import indexImgHelpdialogNormal from 'assets/images/common/index_img_helpdialog_normal.png'
import noDataMonster from 'assets/images/level_up/levelup_img_monster_nodata.png'
import { ref, computed, onMounted } from 'vue'

import { useNuxtApp, useRuntimeConfig } from '#app'
import { useI18n } from '#imports'
import { useLevelBonusInfo } from '@/composables/user/useLevelBonusInfo'
import { useUserInfo } from '@/composables/user/useUserInfo'
import { useMainStore } from '@/stores/main'
import { useUserInfoStore } from '@/stores/user/userInfo'

// Import monster images`
// import rookieNormal from 'assets/images/common/index_img_rookie_normal.png'
// import rookieSelected from 'assets/images/common/index_img_rookie_selected.png'
// import eliteNormal from 'assets/images/common/index_img_elite_normal.png'
// import eliteSelected from 'assets/images/common/index_img_elite_selected.png'
// import proNormal from 'assets/images/common/index_img_pro_normal.png'
// import proSelected from 'assets/images/common/index_img_pro_selected.png'
// import masterNormal from 'assets/images/common/index_img_master_normal.png'
// import masterSelected from 'assets/images/common/index_img_master_selected.png'
// import championNormal from 'assets/images/common/index_img_champion_normal.png'
// import championSelected from 'assets/images/common/index_img_champion_selected.png'
// import legendaryNormal from 'assets/images/common/index_img_legendary_normal.png'
// import legendarySelected from 'assets/images/common/index_img_legendary_selected.png'

const config = useRuntimeConfig()
const { $SoundControl, $analytics } = useNuxtApp()
const { t } = useI18n()
const store = useMainStore()
const userInfoStore = useUserInfoStore()
const { levelBonusInfo } = useLevelBonusInfo()
const visible = ref(false)
const showNeedHelp = ref(true)

// Monster rank images map
// const monsterImages = {
//   guest: { normal: rookieNormal, selected: rookieSelected },
//   elite: { normal: eliteNormal, selected: eliteSelected },
//   pro: { normal: proNormal, selected: proSelected },
//   master: { normal: masterNormal, selected: masterSelected },
//   champion: { normal: championNormal, selected: championSelected },
//   legendary: { normal: legendaryNormal, selected: legendarySelected },
// }

// const getRank = computed(() => {
//   if (config.public.isBtk) {
//     switch (true) {
//       case userInfo.value.level === 0:
//         return 'guest'
//       case userInfo.value.level <= 5:
//         return 'elite'
//       case userInfo.value.level <= 10:
//         return 'pro'
//       case userInfo.value.level <= 15:
//         return 'master'
//       case userInfo.value.level <= 20:
//         return 'champion'
//       case userInfo.value.level <= 25:
//         return 'legendary'
//       default:
//         return 'guest'
//     }
//   } else {
//     switch (true) {
//       case userInfo.value.level === 0:
//         return 'guest'
//       case userInfo.value.level <= 20:
//         return 'elite'
//       case userInfo.value.level <= 40:
//         return 'pro'
//       case userInfo.value.level <= 60:
//         return 'master'
//       case userInfo.value.level <= 80:
//         return 'champion'
//       case userInfo.value.level < 100:
//         return 'legendary'
//       default:
//         return 'guest'
//     }
//   }
// })

// const monsterBackgroundStyle = computed(() => {
//   const rank = getRank.value
//   const imageUrl = visible.value ? monsterImages[rank].selected : monsterImages[rank].normal
//   return {
//     backgroundImage: `url(${imageUrl})`,
//     backgroundPositionY: '-0.25rem'
//   }
// })

const accountLevelReachedImage = computed(() => {
  const arr = levelBonusInfo.value?.accountLevelReachedImage
  return Array.isArray(arr) && arr.length > 0 ? arr[0].url : noDataMonster
})

onMounted(() => {
  setTimeout(() => {
    showNeedHelp.value = false
  }, 4000)
})

const toggle = (name) => {
  showNeedHelp.value = false
  if (visible.value) {
    $SoundControl.sound.play('closeDrawer')
  } else {
    $SoundControl.sound.play('openDrawer')
  }
  visible.value = !visible.value

  if (name !== undefined) {
    $analytics.push({
      event: 'lobby_click',
      location: 'lobby',
      icon: 'Menu',
    })
  }
}
</script>
